import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import type { AutoLabelDefinition } from '@/types/email';

export interface AddSenderToLabelDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  labels: AutoLabelDefinition[];
  selectedLabelId: string;
  onSelectLabel: (labelId: string) => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  error?: string | null;
}

export function AddSenderToLabelDialog({
  open,
  onOpenChange,
  labels,
  selectedLabelId,
  onSelectLabel,
  onConfirm,
  isSubmitting,
  error,
}: AddSenderToLabelDialogProps) {
  const hasLabels = labels.length > 0;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add sender to label</DialogTitle>
          <DialogDescription>Select a sender label to apply automatically.</DialogDescription>
        </DialogHeader>
        {hasLabels ? (
          <Select value={selectedLabelId} onValueChange={onSelectLabel}>
            <SelectTrigger>
              <SelectValue placeholder="Select a label" />
            </SelectTrigger>
            <SelectContent>
              {labels.map((label) => (
                <SelectItem key={label.id} value={label.id}>
                  {label.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ) : (
          <p className="text-sm text-muted-foreground">
            No sender labels available. Create one in Settings to get started.
          </p>
        )}
        {error ? <p className="text-sm text-destructive">{error}</p> : null}
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={!hasLabels || !selectedLabelId || isSubmitting}>
            {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Add label
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
